import React, { Component } from "react";
import "../style/bmw.scss";
import firstImg from "../image/cannes1.jpg";
import tesla_1 from "../image/tesla-1.webm";
import tesla_2 from "../image/tesla-2.avif";
import tesla_3 from "../image/tesla-3.avif";
import tesla_4 from "../image/tesla-4.avif";
import tesla_5 from "../image/tesla-5.avif";
import { routePage } from "../utils/routePage";
import * as PostMessageAPI from "../apis/PostMessageAPI";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import getAd from "../utils/GetAd";
import TeslaIcon from "../icon/TeslaIcon";
import { lang, t } from "../utils/lang";
import PagePath from "../constants/router/PagePath";

class BMW extends Component {
  constructor(props) {
    super(props);
    this.state = {
      driveNum: "",
      ad: getAd(),
    };
    this.back = this.back.bind(this);
  }
  componentDidMount() {
    // PostMessageAPI.postMessage(BASE_URL + "[Video Page]");
    window.scrollTo(0, 0);
    let driveNum = Math.floor(Math.random() * (50 - 200 + 1)) + 200;
    this.setState({ driveNum });
  }

  back() {
    let { history } = this.props;
    history.goBack();
  }

  render() {
    const { driveNum, ad } = this.state;
    let { history, location } = this.props;
    return (
      <React.Fragment>
        <div className="bmw-page">
          <div className="mask font-bold">
            <div className="top-title">
              {t("carsRemaining", { count: driveNum })}
              <span>
                {lang.feedbackWelcome}
              </span>
            </div>

            <div className="logo">
              <TeslaIcon width={150} height={50} color="white" />
            </div>

            <h1>{lang.chooseCars}</h1>
            <h2>{lang.freeYear}</h2>

            <div
              className="btn"
              onClick={() => routePage(history, ad, PagePath.MODEL)}
            >
              {lang.freeTesla}
              {/* <DoubleAllowRight size={21} className="double" color="#333" /> */}
            </div>
          </div>

          <div className="second-row">
            <video
              src={tesla_1}
              autoPlay={true}
              loop={true}
              playsInline={true}
              muted={true}
            ></video>
          </div>
          <div className="first-row tesla-2-row">
            <img
              src={tesla_2}
              alt="Tesla vehicle"
              className="first-img second-img"
            />
          </div>
          <div className="first-row">
            <img src={tesla_3} alt="Tesla vehicle" className="first-img" />
          </div>
          <div className="first-row">
            <img src={tesla_4} alt="Tesla vehicle" className="first-img" />
          </div>
          <div className="first-row">
            <img src={tesla_5} alt="Tesla vehicle" className="first-img" />
          </div>
         
        </div>
      </React.Fragment>
    );
  }
}

export default BMW;
